module.exports = __webpack_public_path__ + "ed74953eb4263d232d4347b86a445617.svg";